<template>
  <span>
    <DatePicker
      v-model="base"
      @change="handleBaseChange"
    />

    <Checkbox
      v-model="showContrast"
      style="margin: 0 10px"
      @change="handleCheckbox"
    >
      {{ contrastText }}
    </Checkbox>

    <DatePicker
      v-if="showContrast"
      v-model="contrast"
      @change="handleContrastChange"
    />
  </span>
</template>

<script>
import moment from 'moment';
import { Checkbox } from 'element-ui';

import DatePicker from './Index';

export default {
  components: {
    DatePicker,
    Checkbox,
  },

  props: {
    defaultDate: {
      type: Array,
      default: () => [],
    },

    contrastText: {
      type: String,
      default: '时间对比',
    },

    isContrast: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      base: this.defaultDate,
      contrast: null,
      showContrast: this.isContrast,
    };
  },

  watch: {
    isContrast(newVal) {
      this.showContrast = newVal;
      if (newVal === false) {
        this.contrast = null;
      }
    },
  },

  methods: {
    handleChange() {
      this.$emit('change', [this.base, this.contrast]);
    },

    handleCheckbox() {
      if (this.showContrast) {
        this.getContrast();
        this.$emit('update:isContrast', true);
      } else {
        this.contrast = null;
        this.$emit('update:isContrast', false);
      }
      this.handleChange();
    },

    getContrast() {
      const start = moment(this.base[0]);
      const end = moment(this.base[1]);
      const interval = end.diff(start, 'days');
      this.contrast = [
        moment(start).subtract(1 + interval, 'day'),
        moment(start).subtract(1, 'day'),
      ];
    },

    getBase() {
      if (!this.contrast) return;

      const start = moment(this.contrast[0]);
      const end = moment(this.contrast[1]);
      const interval = end.diff(start, 'days');
      this.base = [
        moment(end).add(1, 'day'),
        moment(end).add(1 + interval, 'day'),
      ];
    },

    // 基础时间变化
    handleBaseChange() {
      if (this.showContrast) {
        this.getContrast();
      }
      this.handleChange();
    },

    // 对比时间变化
    handleContrastChange() {
      this.getBase();
      this.handleChange();
    },
  },
};
</script>
